import React from "react";
import MDatePicker from "react-datepicker";

class Layout1 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="pickerContainer">
                <MDatePicker 
                    dateFormat={this.props.dateFormat}
                    inline
                    useWeekdaysShort={true}
                    shouldCloseOnSelect={false}
                    minDate={this.props.minDate}
                    maxDate={this.props.maxDate}
                    selected={this.props.selected}
                    onChange={this.props.onChange}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    selectsStart={this.props.selectsStart}
                    selectsEnd={this.props.selectsEnd}
                />
            </div>
        )
    }
}

export default Layout1;